import type {AxiosInstance} from "axios";

export interface GitState {
    commits: unknown[]
}

type NoGitState = Record<string, never>

interface ResultContainer<T> {
    success: boolean
    result: T
}

export interface MetlGitApi {
    id: string

    getState(): Promise<GitState | null>

    getRemoteUrl(): Promise<string | null>
}

export function metlGitApi(axios: AxiosInstance, baseUrl: string, id: string): MetlGitApi {
    return {
        id: `${id}/git`,
        async getRemoteUrl(): Promise<string | null> {
            const result = await axios.get<ResultContainer<string>>(`${baseUrl}/scm/remote`)
            const data = result.data
            if(!data.success) return null
            return data.result
        },
        async getState(): Promise<GitState | null> {
            const result = await axios.get<ResultContainer<GitState | NoGitState>>(`${baseUrl}/scm/getState`)
            const data = result.data
            if(data.success && "commits" in data.result) {
                return data.result as GitState
            }
            return null
        }
    }
}